import { setNews } from "../common/functions/setNews.es6";
import { trimNews } from "../common/functions/trimNews.es6";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector(".c-news__list")) {
            setNews(10);
            trimNews();
            this.onScroll(); //newsDOMを生成してから実行
        }

        this.setShare();
        this.setCategory();
        this.activeCategory();
    }

    setCategory() {
        const cwindow = document.querySelector(".c-news__categorylist_window");
        const btn = [...document.querySelectorAll(".c-news__categorylist__item")];

        btn.forEach((el) => {
            el.addEventListener("click", () => {
                cwindow.classList.add("-active");
            });
        });

        cwindow.addEventListener("click", () => {
            cwindow.classList.remove("-active");
        });
    }

    activeCategory() {
        //カテゴリーのアクティブ化
        const items = document.querySelectorAll(".c-news__categorylist__item");
        let anycategory = false;

        items.forEach((el) => {
            if (location.href.indexOf(el.getAttribute("data-category")) != -1) {
                el.classList.add("-active");
                anycategory = true;
            }
        });

        if (!anycategory) {
            items[0].classList.add("-active");
        }

        //SPナビのアクティブ化
        const c_category = document.querySelector(".c-news__categorylist__item.-active").getAttribute("data-category");
        document.querySelector(".js-category_current").textContent = c_category.toUpperCase();
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-newsscrollreveal")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });
    }

    setShare() {
        const btn = [...document.querySelectorAll(".js-setshare")];
        const text = encodeURIComponent(`${document.title} ${location.href}`);
        const snsURL = {
            twitter: "https://twitter.com/intent/tweet?text=" + text,
            facebook: "https://www.facebook.com/sharer.php?u=",
            line: "http://line.naver.jp/R/msg/text/?" + text,
        };

        btn.forEach((el) => {
            const elm = el.querySelector("a");
            elm.setAttribute("href", snsURL[el.getAttribute("data-sns")]);
        });
    }
}
